export default "__VITE_ASSET__722d0803__"